import React from 'react';
import { createFileRoute, Outlet } from '@tanstack/react-router';

import Layout from '@pages/layout/ui/Layout';

const Component = () => (
  <Layout>
    <Outlet />
  </Layout>
);

export const Route = createFileRoute('/_auth/_layout')({
  component: Component,
});
